import Big from 'big.js';
import { formatWithCommas } from '../../utils/numbers';
export const formatWithCommas_usd = (value: string | number) => {
  if (isInvalid(value)) return '$-';
  const big = Big(value);
  if (big.eq(0)) {
    return '$0';
  } else if (big.lt(0.01)) {
    return '<$0.01';
  } else if (big.lt(10000)) {
    return '$' + formatWithCommas(big.toFixed(2, 1));
  } else {
    return '$' + formatWithCommas(big.toFixed(0, 1));
  }
};

export const formatPercentage = (value: string | number) => {
  if (isInvalid(value)) return '-%';
  const big = Big(value);
  if (big.eq(0)) {
    return '0%';
  } else if (big.lt(0.01)) {
    return '<0.01%';
  } else {
    return big.toFixed(2, 1) + '%';
  }
};
export const formatNumber = (
  value: string | number,
  type?: 'down' | 'both'
) => {
  if (isInvalid(value)) return '-';
  const big = Big(value);
  if (big.eq(0)) {
    return '0';
  } else if (big.lt(0.01)) {
    return '<0.01';
  } else {
    return type == 'down' ? big.toFixed(2, 0) : big.toFixed(2, 1);
  }
};
export const formatWithCommas_number = (value: string | number) => {
  if (isInvalid(value)) return '-';
  const big = Big(value);
  if (big.eq(0)) {
    return '0';
  } else if (big.lt(0.01)) {
    return '<0.01';
  } else {
    return formatWithCommas(big.toFixed(2, 1));
  }
};
export const formatPriceWithCommas = (value: string | number) => {
  if (isInvalid(value)) return '-';
  const big = Big(value);
  if (big.eq(0)) {
    return '0';
  } else if (big.lt(0.0001)) {
    return '<0.0001';
  } else {
    const fixedPrice = big.toFixed(4, 0);
    const [whole, decimal] = fixedPrice.split('.');
    return `${formatWithCommas(whole)}${decimal ? '.' + decimal : ''}`;
  }
};
export const isInvalid = function (value: any) {
  if (value === '' || value === undefined || value === null || value === '-')
    return true;
  return false;
};

export function isValid(value: number) {
  if (value !== undefined && value !== null) return true;
  return false;
}
function createRandomChar(charRange = 'a-z') {
  switch (charRange) {
    case 'A-Z':
      return String.fromCharCode(Math.trunc(Math.random() * 25) + 65);
    case 'a-z':
      return String.fromCharCode(Math.trunc(Math.random() * 25) + 97);
    case '0-9':
    default:
      return String.fromCharCode(Math.trunc(Math.random() * 10) + 48);
  }
}
export function createRandomString(length = 4) {
  let randomString = '';
  for (let charIndex = 0; charIndex < length; charIndex++)
    randomString += createRandomChar();
  return randomString;
}
